import { useSessionPermission } from '@btime/react-session'
import React from 'react'

import { useOpenEditGroupModal } from '../../../utils/routes/modals/modalsActions'
import FixedRoundButton from '../../../components/actions/FixedRoundButton'

const AddNewButton = () => {
  const canSetupUser = useSessionPermission('setupUser')

  const canCreateGroup = useSessionPermission('createUserGroup')

  const openModal = useOpenEditGroupModal()

  if (!canSetupUser || !canCreateGroup) return false

  return <FixedRoundButton onClick={openModal} />
}

export default AddNewButton
